export enum ToolOwnerTWId {
  PatrickDecker = '0001018447',
  JonasKarstrom = '0001022791',
  JimmieAnderson = '0009320699',
  KarenOKeeffe = '0001006345',
  AnubhavMathur = '0001018783',
  MarianaMelodeAndradeLima = '0001007816',
  HeidiWillocks = '0001017043',
  ChrisBaily = '0006936978',
  MatthewMahony = '0001004402',
  LyssaFineman = '0001018347',
  GloRobinson = '0001034234',
  TonyCheng = '0001009311',
  SimoneWicksMeighan = '0001015555',
  ErnestPowers = '0006940742',
  DavidStehlik = '0006974523',
  JesusPantaleon = '0006966820',
  DanielNassab = '0001026858',
  SathishDevadoss = '0001043233',
  AntonWestman = '0001019511',
  MatthewWall = '0006993238',
  NehaSingh = '0001016666',
  ParkerNomura = '0001002962',
  JiunweiChen = '0006982131',
}

export enum PagerDutyTeam {
  CommerceStudio = 'COMMERCE_STUDIO',
  Studio = 'STUDIO',
  Mosaic = 'MOSAIC',
  FraudAbuse = 'FRAUD_ABUSE',
  Gprp = 'GPRP',
}

export interface PagerDutyTeamConfig {
  PDTeamName: string;
  PDTeamURL: string;
}
export type PagerDutyTeamConfigMap = Record<PagerDutyTeam, PagerDutyTeamConfig>;

export const pagerDutyTeamConfigMap: PagerDutyTeamConfigMap = {
  [PagerDutyTeam.CommerceStudio]: {
    PDTeamName: 'COM CS Commerce Studio',
    PDTeamURL: 'https://discoveryinc.pagerduty.com/teams/PAPS3TJ/users',
  },
  [PagerDutyTeam.Studio]: {
    PDTeamName: 'Studio - Bolt',
    PDTeamURL: 'https://discoveryinc.pagerduty.com/teams/P991DOG/users',
  },
  [PagerDutyTeam.Mosaic]: {
    PDTeamName: 'Mosaic',
    PDTeamURL: 'https://discoveryinc.pagerduty.com/teams/PS96HRW/users',
  },
  [PagerDutyTeam.FraudAbuse]: {
    PDTeamName: 'Fraud & Abuse',
    PDTeamURL: 'https://discoveryinc.pagerduty.com/teams/PO98GV5/users',
  },
  [PagerDutyTeam.Gprp]: {
    PDTeamName: 'GPRP',
    PDTeamURL: 'https://discoveryinc.pagerduty.com/teams/PDA0RK6/users',
  },
};
export function getPagerDutyTeamConfig(
  PDTeamName: PagerDutyTeam,
): PagerDutyTeamConfig {
  return pagerDutyTeamConfigMap[PDTeamName];
}
export function getPagerDutyTeamUrl(PDTeam: PagerDutyTeam): string {
  return pagerDutyTeamConfigMap[PDTeam].PDTeamURL;
}

export enum SlackSupportChannel {
  Commerce = 'COMMERCE_SUPPORT',
  General = 'STUDIO_SUPPORT',
  Labs = 'LABS_SUPPORT',
  ContentMerch = 'CONTENT_MERCH_SUPPORT',
  Mosaic = 'MOSAIC_SUPPORT',
  Consumer = 'CONSUMER_SUPPORT',
  Localization = 'LOCALIZATION_SUPPORT',
  FraudAbuseDiana = 'FRAUD_ABUSE_DIANA_SUPPORT',
  FraudAbuseFlash = 'FRAUD_ABUSE_FLASH_SUPPORT',
  TrustSafety = 'TRUST_SAFETY_SUPPORT',
}

export interface SlackSupportChannelConfig {
  label: string;
  color?: string;
  channelName: string;
  channelUrl: string;
}

export type SlackSupportChannelConfigMap = Record<
  SlackSupportChannel,
  SlackSupportChannelConfig
>;
const slackSupportChannelConfigMap: SlackSupportChannelConfigMap = {
  [SlackSupportChannel.Commerce]: {
    channelName: '#core-commerce-support',
    channelUrl: 'https://wbdstreaming.slack.com/archives/C04EEL3MS0G',
    label: 'Commerce Support',
  },
  [SlackSupportChannel.General]: {
    channelName: '#studio-support',
    channelUrl: 'https://wbdstreaming.slack.com/archives/C049R4RR9U7',
    label: 'Studio Support',
  },
  [SlackSupportChannel.Labs]: {
    channelName: '#labs-eng-support',
    channelUrl: 'https://wbdstreaming.slack.com/archives/C04F8THMJAX',
    label: 'Labs Support',
  },
  [SlackSupportChannel.ContentMerch]: {
    channelName: '#merchex-intake-support',
    channelUrl: 'https://warnermedia.enterprise.slack.com/archives/C04EEL3MS0G',
    label: 'Content Merch Support',
  },
  [SlackSupportChannel.Mosaic]: {
    channelName: '#mosaic-support',
    channelUrl: 'https://warnermedia.enterprise.slack.com/archives/C04EEL3MS0G',
    label: 'Mosaic Support',
  },
  [SlackSupportChannel.Consumer]: {
    channelName: '#ask-core-gi',
    channelUrl: 'https://wbdstreaming.slack.com/archives/C04FYTFGJGY',
    label: 'Consumer Support',
  },
  [SlackSupportChannel.Localization]: {
    channelName: '#wbd-max-localization',
    channelUrl: 'https://warnermedia.enterprise.slack.com/archives/C04CV7BR30V',
    label: 'Localization',
  },
  [SlackSupportChannel.FraudAbuseDiana]: {
    channelName: '#taz_faa_diana',
    channelUrl: 'https://warnermedia.enterprise.slack.com/archives/C05DFPY9WUE',
    label: 'Fraud & Abuse - DIANA',
  },
  [SlackSupportChannel.FraudAbuseFlash]: {
    channelName: '#taz_faa_flash',
    channelUrl: 'https://warnermedia.enterprise.slack.com/archives/C07A0EVLP53',
    label: 'Fraud & Abuse - FLASH',
  },
  [SlackSupportChannel.TrustSafety]: {
    channelName: '#ask-trust-and-safety',
    channelUrl: 'https://warnermedia.enterprise.slack.com/archives/C04JQABG0BG',
    label: 'Trust & Safety',
  },
};
export function getSlackSupportChannelConfig(
  channel: SlackSupportChannel,
): SlackSupportChannelConfig {
  return slackSupportChannelConfigMap[channel];
}
export function getSlackSupportChannelUrl(
  channel: SlackSupportChannel,
): string {
  return slackSupportChannelConfigMap[channel].channelUrl;
}
export function getSlackSupportChannelName(
  channel: SlackSupportChannel,
): string {
  return slackSupportChannelConfigMap[channel].channelName;
}
